/**
 * The one main button on an Insurance Verification row, from what the row
 * carries. "reply" is the Details Needed checklist our team sent on a breakdown
 * request (the Provide details form); "fix" the older blank-critical-fields
 * path; "resubmit" everything else waiting on the office; "view" a finished
 * answer. An estimate or claim waiting on the office reads "View Results": it
 * opens what our team found and lets the office update us (RequestResultsModal).
 */
import { needsSubmissions } from "./requestTypes";

export function primaryAction(row) {
  if (!row) return null;
  const waiting = row.status === "ready" && !!row.waiting_on_office;
  if (waiting) {
    if (row.request_type === "breakdown" && row.info_ask && !row.info_ask.answered_at) return "reply";
    if (Array.isArray(row.missing_fields) && row.missing_fields.length > 0) return "fix";
    return "resubmit";
  }
  const viewable = needsSubmissions(row.request_type) ? row.status !== "cancelled" : !!row.completed_at;
  return viewable ? "view" : null;
}

/** The primary button's words for an action. "resubmit" on an estimate or a
 * claim reads "View Results" — what's waiting is our team's result, and the
 * office answers it by updating us, not by resubmitting anything; a breakdown
 * on an old flag (no checklist) keeps "Resubmit". */
export function actionLabel(row, action) {
  if (action === "resubmit") {
    return row && needsSubmissions(row.request_type) ? "View Results" : "Resubmit";
  }
  return null;
}
